import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'memberSearch',
    standalone: false
})
export class MemberSearchPipe implements PipeTransform {

  transform(resources: any[], searchText: string, memberAdvancedSearch: Array<any> = []): any[] {
    if (resources && resources.length) {
      return resources.filter(groupData => {
        if (searchText) {
          if (searchText && groupData.GROUP_NAME.toLowerCase().indexOf(searchText.toLowerCase()) === -1
            && groupData.GROUP_NUMBER.toLowerCase().indexOf(searchText.toLowerCase()) === -1) {
            return false;
          }
        } else {
          // advanced search
          if (memberAdvancedSearch[0] && groupData.GROUP_NAME.toLowerCase().indexOf(memberAdvancedSearch[0].toLowerCase()) === -1) {
            return false;
          }
          if (memberAdvancedSearch[1] && groupData.GROUP_NUMBER.toLowerCase().indexOf(memberAdvancedSearch[1].toLowerCase()) === -1) {
            return false;
          }
          if (memberAdvancedSearch[2] && groupData.CORP_ID.toLowerCase().indexOf(memberAdvancedSearch[2].toLowerCase()) === -1) {
            return false;
          }
          if (memberAdvancedSearch[3] && groupData.MEMBER_FIRST_NAME.toLowerCase().indexOf(memberAdvancedSearch[3].toLowerCase()) === -1) {
            return false;
          }
          if (memberAdvancedSearch[4] && groupData.MEMBER_LAST_NAME.toLowerCase().indexOf(memberAdvancedSearch[4].toLowerCase()) === -1) {
            return false;
          }
          if (memberAdvancedSearch[5] && groupData.MEMBER_ID.toLowerCase().indexOf(memberAdvancedSearch[5].toLowerCase()) === -1) {
            return false;
          }
          if (memberAdvancedSearch[6] && groupData.MEMBER_SSN.toLowerCase().indexOf(memberAdvancedSearch[6].toLowerCase()) === -1) {
            return false;
          }
          if (memberAdvancedSearch[7] && groupData.VISA_NUMBER.toLowerCase().indexOf(memberAdvancedSearch[7].toLowerCase()) === -1) {
            return false;
          }
          if (memberAdvancedSearch[8] && groupData.MARKET_SEGMENT.toLowerCase().indexOf(memberAdvancedSearch[8].toLowerCase()) === -1) {
            if (memberAdvancedSearch[8] !== 'all') { return false; }
          }
          if (memberAdvancedSearch[9] && groupData.BUSINESS_TYPE.toLowerCase().indexOf(memberAdvancedSearch[9].toLowerCase()) === -1) {

            if (memberAdvancedSearch[9] !== 'all') { return false; }
          }
          if (memberAdvancedSearch[10] && groupData.GROUP_STATUS.toLowerCase().indexOf(memberAdvancedSearch[10].toLowerCase()) === -1) {

            if (memberAdvancedSearch[10] !== 'all') { return false; }
          }
          if (memberAdvancedSearch[11] === 'effectiveDate') {

            if (memberAdvancedSearch[12] && groupData.EFFECTIVE_DATE.toLowerCase().indexOf(memberAdvancedSearch[12].toLowerCase()) === -1) {
              return false;
            }

          } else if (memberAdvancedSearch[11] === 'termDate') {

            if (memberAdvancedSearch[12] && groupData.TERM_DATE.toLowerCase().indexOf(memberAdvancedSearch[12].toLowerCase()) === -1) {
              return false;
            }

          } else if (memberAdvancedSearch[11] === 'renewalDate') {

            if (memberAdvancedSearch[12]
              && groupData.RENEWAL_EFFECTIVE_DATE.toLowerCase().indexOf(memberAdvancedSearch[12].toLowerCase()) === -1) {
              return false;
            }
          }
          if (memberAdvancedSearch[13] && groupData.GENERAL_AGENCY.toLowerCase().indexOf(memberAdvancedSearch[13].toLowerCase()) === -1) {
            return false;
          }
          if (memberAdvancedSearch[14] && groupData.ACCOUNT_MANAGER.toLowerCase().indexOf(memberAdvancedSearch[14].toLowerCase()) === -1) {
            return false;
          }
          if (memberAdvancedSearch[15]
            && groupData.SALES_REPRESENTATIVE.toLowerCase().indexOf(memberAdvancedSearch[15].toLowerCase()) === -1) {

            return false;
          }
          if (memberAdvancedSearch[16] && groupData.SALES_SUPPORT.toLowerCase().indexOf(memberAdvancedSearch[16].toLowerCase()) === -1) {
            return false;
          }
          if (memberAdvancedSearch[17] && groupData.AGENT_NAME.toLowerCase().indexOf(memberAdvancedSearch[17].toLowerCase()) === -1) {
            return false;
          }
          if (memberAdvancedSearch[18] && groupData.GROUP_ADMIN.toLowerCase().indexOf(memberAdvancedSearch[18].toLowerCase()) === -1) {
            return false;
          }
        }
        return true;
      });
    } else {
      return resources;
    }
  }

}
